import {connect} from "react-redux";
import {Typography} from "@mui/material";
import {useEffect} from "react";
import {useState} from "react";
import { setItem } from "../utils/DataProtection";
export default connect(
  ({
    // to use redux states here
    i18n,
    isLoading,
    orderSubscription,
  }) => ({
    i18n,
    isLoading,
    orderSubscription,
  }),
  {
    // redux functions
  }
)((props, {}) => {
  let i18n = props.i18n;
  const {planTitle, userNumber, cost} = props.orderSubscription;
  const [total, setTotal] = useState();
  useEffect(() => {
    // Ensure both cost and userNumber are valid before performing the calculation
    const validCost = parseFloat(cost) || 0;
    const validUserNumber = parseInt(userNumber, 10) || 0;

    let total = validCost * validUserNumber;
    setItem("total",total.toFixed(2));
    setTotal(total.toFixed(2)); // Format to two decimal places
  }, [cost, userNumber]);
  // useEffect(() => {
  //   let total = cost * userNumber;
  //   setTotal(total.toFixed(2));
  // }, [props.orderSubscription]);

  return (
    <div className="card-service-abo">
      <Typography variant="h1">{i18n.abo_title}</Typography>

      <Typography variant="span" className="card-text">
        {planTitle}{" "}
        <span className="dark-text">
          {cost !== undefined ? `${cost}€` : ""}
        </span>
      </Typography>

      <div className="text-space">
        <span>{i18n.number_of_packages}</span>
        <span className="number-of-package">{userNumber}</span>
      </div>
      <Typography variant="span" className="card-text">
        {i18n.total_price}
        <span className="dark-text">{`${total}€`}</span>
      </Typography>
      {/* <span className="text">zzgl. 19% USt.</span>
        <span className="text">Gesamtpreis (brutto)</span> */}
      <div className="card-frame">
        {/* <div>
          <p className="checkMark-text">
            <img className="icon" src="../images/check_circle.svg" />
            Laufzeit: 12 Monate, 1 Monat Kündigungsfrist
          </p>
          <p className="checkMark-text">
            <img className="icon" src="../images/check_circle.svg" />
            Automatische Verlängerung ab 18.05.2025
          </p>
          <p className="checkMark-text">
            <img className="icon" src="../images/check_circle.svg" />
            Abrechnung im ersten Monat für 12 Monate
          </p>
        </div> */}
      </div>
    </div>
  );
});
